import { ICON_HEIGHT_16 } from '../../../../Icon'

import ThumbnailsIcon from '../../../../../icons/preview.svg'

export const PDF_VIEWER_TOOLBAR_THUMBNAILS_ICON_PROPS = {
  Icon: ThumbnailsIcon,
  svgSize: ICON_HEIGHT_16,
}

export const QA_NAME_PDF_VIEWER_TOOLBAR_THUMBNAILS_BTN =
  'pdfViewerToolbarThumbnails'
